module.exports = __webpack_public_path__ + "img/kims_logo.42845b32.svg";